import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormContext } from './Form';
import { Button } from '../Buttons';

const Submit = ({ children, ...rest }) => {
  const {
    submitting,
    phrases: { processing },
  } = useContext(FormContext);

  return (
    <div className="ss_field">
      <Button type="submit" disabled={submitting} {...rest}>
        {submitting ? processing : children}
      </Button>
    </div>
  );
};

Submit.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Submit };
